import React, { useState, useEffect, useRef } from "react";
import "../CSS/WithdrawalDashboard.css";
import styles from '../CSS/AgentHome.module.css';

import { GoArrowRight } from "react-icons/go";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../AuthContext";

import Loading from '../Components/Loading';
import Error from '../Components/Error';

const AgentDeposit = () => {
    const { fetchData } = useAuth();

    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');

    const navigate = useNavigate();

    const [rate, setRate] = useState(0)
    const [symbol, setSymbol] = useState('')
    const [records, setRecords] = useState([]);

    const [totalRecords, setTotalRecords] = useState(0)

    const [deposit, setDeposit] = useState({
        total: 0,
        today: 0
    })

    const recordsPerPage = 100;
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(totalRecords / recordsPerPage);

    const displayError = (message) => {
        setIsError(true);
        setErrorText(message);

        const timerId = setTimeout(() => {
            setIsError(false);
            setErrorText('');
        }, 1500);

        return () => clearTimeout(timerId);
    };

    async function getData(page = 1) {
        setLoader(true);

        try {
            const data = await fetchData('/admin/agent/recharge/records?page=' + page);
            setLoader(false);

            setRecords(data.records);
            setSymbol(data.symbol);
            setRate(data.rate);

            setTotalRecords(data.deposit.no)
            
            setDeposit({
                total: data.deposit.amount,
                today: data.today
            });
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    useEffect(() => {
        getData(currentPage);
    }, [currentPage])

    const handleFullScreen = (e) => {
        if (e.target.requestFullscreen) {
            e.target.requestFullscreen();
        }
    };

    const goToPage = (pageNum) => {
        if (pageNum >= 1 && pageNum <= totalPages && pageNum !== currentPage) {
            setCurrentPage(pageNum);
        }
    };

    const renderPagination = () => {
        const pages = [];
        const edgeCount = 3;

        const addPage = (p) => {
            pages.push(
                <button
                    key={p}
                    onClick={() => goToPage(p)}
                    className={p === currentPage ? "active" : ""}
                >
                    {p}
                </button>
            );
        };

        pages.push(
            <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1} key="prev">
                &lt;
            </button>
        );

        for (let i = 1; i <= Math.min(edgeCount, totalPages); i++) addPage(i);

        if (currentPage > edgeCount + 1) pages.push(<span key="start-ellipsis">...</span>);

        const startMiddle = Math.max(edgeCount + 1, currentPage - 1);
        const endMiddle = Math.min(totalPages - edgeCount, currentPage + 1);

        for (let i = startMiddle; i <= endMiddle; i++) {
            if (i <= totalPages) addPage(i);
        }

        if (currentPage < totalPages - edgeCount) pages.push(<span key="end-ellipsis">...</span>);

        for (let i = totalPages - edgeCount + 1; i <= totalPages; i++) {
            if (i > edgeCount) addPage(i);
        }

        pages.push(
            <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages} key="next">
                &gt;
            </button>
        );

        return <div className="pagination">{pages}</div>;
    };

    return (
        <div className="dashboard">
            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className={styles.topbar}>
                <div className={styles.left}>
                    <h1>Deposit Records</h1>
                </div>

                <div className={styles.right} style={{
                    display: "flex",
                    alignItems: "center",
                }} onClick={() => navigate(-1)}>
                    <div>Go Back</div>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: 20
                    }}>
                        <GoArrowRight />
                    </div>
                </div>
            </div>

            <div className="summary-container">
                <div className="card">
                    <h2>Today's Deposit</h2>
                    <p className="amount">{deposit.today}<span> {symbol}</span></p>
                    <p>${deposit.today * rate} USD</p>
                </div>
                <div className="card">
                    <h2>Total Deposits</h2>
                    <p className="amount">{deposit.total}<span> {symbol}</span></p>
                    <p>${deposit.total * rate} USD</p>
                </div>
            </div>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Deposit Amount</th>
                            <th>Proof of payment</th>
                        </tr>
                    </thead>
                    <tbody>
                        {records.map((w, i) => {
                            const imageUrl = `data:${w.proof?.contentType};base64,${w.proof?.image}`;

                            return (
                                (
                                    <tr key={i}>
                                        <td>
                                            <div>{w.orderId}</div>
                                            <div className="subtext">{w.date}</div>
                                        </td>
                                        <td>
                                            <div>{w.convertedAmount} {symbol}</div>
                                            <div className="subtext">${w.amount} USD</div>
                                        </td>
                                        <td>
                                            <img src={imageUrl} onClick={handleFullScreen} alt="" height={50} />
                                        </td>
                                    </tr>
                                )
                            )
                        })}
                    </tbody>
                </table>
            </div>


            {renderPagination()}
        </div>
    );
};

export default AgentDeposit;